"use strict";
// import type { FunctionHandler } from '../../../../../types/nodeEngine';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISBLANK = void 0;
exports.ISBLANK = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        const [input] = inputs;
        if (input === undefined) {
            return { error: null, result: true };
        }
        if (input === null) {
            return { error: null, result: true };
        }
        if (typeof input === 'string' && input.trim() === '') {
            return { error: null, result: true };
        }
        return { error: null, result: false };
    },
};
//# sourceMappingURL=isblank.js.map